export default __webpack_public_path__ + "static/media/DJI_0988.MP4.00_00_43_05.Still003.0387e1fa.jpg";